// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#add-integration-form {
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  #add-integration-form {
    height: 100vh;
  }
}
#add-integration-form .add-integration-form-body {
  display: flex;
  height: calc(100vh - 6.25rem);
}
@media (max-width: 768px) {
  #add-integration-form .add-integration-form-body {
    height: 100%;
  }
}
#add-integration-form .add-integration-form-body .add-integration-form-left {
  width: 60%;
  overflow-y: overlay;
  padding-left: 5rem;
  padding-right: 5rem;
}
@media (max-width: 768px) {
  #add-integration-form .add-integration-form-body .add-integration-form-left {
    width: 100%;
    padding: 1rem;
  }
  #add-integration-form .add-integration-form-body .add-integration-form-left .ant-row {
    display: block;
    flex-flow: unset;
  }
}
#add-integration-form .add-integration-form-body .add-integration-form-left .header {
  padding-top: 2.5rem;
  padding-left: 0;
}
@media (max-width: 768px) {
  #add-integration-form .add-integration-form-body .add-integration-form-left .header {
    padding: 0rem;
    margin: 0rem;
  }
}
#add-integration-form .add-integration-form-body .add-integration-form-left .header .close-button {
  margin-right: 0.65rem;
}
#add-integration-form .add-integration-form-body .add-integration-form-left .gyramais-alert {
  margin-bottom: 0rem;
}
#add-integration-form .add-integration-form-body .add-integration-form-left .ant-form-item {
  margin-bottom: 0rem !important;
  margin-top: 2rem !important;
}
#add-integration-form .add-integration-form-body .add-integration-form-left .ant-row form {
  width: 100%;
  display: flex;
}
#add-integration-form .add-integration-form-body .add-integration-form-left .add-integration-form-left-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 2.5rem 0;
}
@media (max-width: 768px) {
  #add-integration-form .add-integration-form-body .add-integration-form-left .add-integration-form-left-title {
    padding: 1rem 0;
    padding-top: 1.5rem;
  }
}
#add-integration-form .add-integration-form-body .add-integration-form-left .add-integration-form-left-title img {
  margin-left: 0.85rem;
  height: 2.5rem;
}
@media (max-width: 768px) {
  #add-integration-form .add-integration-form-body .add-integration-form-left .add-integration-form-left-title img {
    height: 1.85rem;
  }
}
#add-integration-form .add-integration-form-body .add-integration-form-left .add-integration-form-left-body .ant-col-lg-12,
#add-integration-form .add-integration-form-body .add-integration-form-left .add-integration-form-left-body .ant-col-lg-24 {
  padding: 0 1rem;
}
#add-integration-form .add-integration-form-body .add-integration-form-right {
  width: 40%;
  height: 100%;
  background-color: #f7f7f7;
  overflow-y: overlay;
}
@media (max-width: 768px) {
  #add-integration-form .add-integration-form-body .add-integration-form-right {
    display: none;
  }
}
#add-integration-form .add-tutorial-same-drawer {
  display: none !important;
}
@media (max-width: 768px) {
  #add-integration-form .add-tutorial-same-drawer {
    display: inline !important;
    margin-top: 1rem;
  }
}
#add-integration-form .add-integration-form-footer {
  background-color: white;
  z-index: 2;
  border-top: 0.063rem solid #00000033;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 1.25rem 3.75rem;
}
@media (max-width: 768px) {
  #add-integration-form .add-integration-form-footer {
    position: absolute;
    bottom: 0;
    max-width: 100vw;
    padding: 1rem;
  }
  #add-integration-form .add-integration-form-footer .gyramais-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/IntegrationsForm/styles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AACE;EAAA;IACE,aAAA;EAEF;AACF;AARA;EASI,aAAA;EACA,6BAAA;AAEJ;AAAI;EAAA;IACE,YAAA;EAGJ;AACF;AAjBA;EAiBM,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAGN;AADM;EAAA;IACE,WAAA;IACA,aAAA;EAIN;EANI;IAKI,cAAA;IACA,gBAAA;EAIR;AACF;AAjCA;EAiCQ,mBAAA;EACA,eAAA;AAGR;AADQ;EAAA;IACE,aAAA;IACA,YAAA;EAIR;AACF;AA3CA;EA0CU,qBAAA;AAIV;AA9CA;EA+CQ,mBAAA;AAER;AAjDA;EAmDQ,8BAAA;EACA,2BAAA;AACR;AArDA;EAyDU,WAAA;EACA,aAAA;AADV;AAzDA;EA+DQ,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAHR;AAKQ;EAAA;IACE,eAAA;IACA,mBAAA;EAFR;AACF;AArEA;EA0EU,oBAAA;EACA,cAAA;AAFV;AAIU;EAAA;IACE,eAAA;EADV;AACF;AA9EA;;EAsFU,eAAA;AAJV;AAlFA;EA4FM,UAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AAPN;AASM;EAAA;IACE,aAAA;EANN;AACF;AA7FA;EAwGI,wBAAA;AARJ;AASI;EAAA;IACE,0BAAA;IACA,gBAAA;EANJ;AACF;AAtGA;EAgHI,uBAAA;EACA,UAAA;EACA,oCAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;AAPJ;AASI;EAAA;IACE,kBAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;EANJ;EAEE;IAOI,WAAA;EANN;AACF","sourcesContent":["#add-integration-form {\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: @md-screen) {\n    height: 100vh;\n  }\n\n  .add-integration-form-body {\n    display: flex;\n    height: calc(100vh - 6.25rem);\n\n    @media (max-width: @md-screen) {\n      height: 100%;\n    }\n\n    .add-integration-form-left {\n      width: 60%;\n      overflow-y: overlay;\n      padding-left: 5rem;\n      padding-right: 5rem;\n\n      @media (max-width: @md-screen) {\n        width: 100%;\n        padding: 1rem;\n\n        .ant-row {\n          display: block;\n          flex-flow: unset;\n        }\n      }\n\n      .header {\n        padding-top: 2.5rem;\n        padding-left: 0;\n\n        @media (max-width: @md-screen) {\n          padding: 0rem;\n          margin: 0rem;\n        }\n\n        .close-button {\n          margin-right: 0.65rem;\n        }\n      }\n\n      .gyramais-alert {\n        margin-bottom: 0rem;\n      }\n\n      .ant-form-item {\n        margin-bottom: 0rem !important;\n        margin-top: 2rem !important;\n      }\n\n      .ant-row {\n        form {\n          width: 100%;\n          display: flex;\n        }\n      }\n\n      .add-integration-form-left-title {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        padding: 2.5rem 0;\n\n        @media (max-width: @md-screen) {\n          padding: 1rem 0;\n          padding-top: 1.5rem;\n        }\n\n        img {\n          margin-left: 0.85rem;\n          height: 2.5rem;\n\n          @media (max-width: @md-screen) {\n            height: 1.85rem;\n          }\n        }\n      }\n\n      .add-integration-form-left-body {\n        .ant-col-lg-12,\n        .ant-col-lg-24 {\n          padding: 0 1rem;\n        }\n      }\n    }\n\n    .add-integration-form-right {\n      width: 40%;\n      height: 100%;\n      background-color: #f7f7f7;\n      overflow-y: overlay;\n\n      @media (max-width: @md-screen) {\n        display: none;\n      }\n    }\n  }\n\n  .add-tutorial-same-drawer {\n    display: none !important;\n    @media (max-width: @md-screen) {\n      display: inline !important;\n      margin-top: 1rem;\n    }\n  }\n\n  .add-integration-form-footer {\n    background-color: white;\n    z-index: 2;\n    border-top: 0.063rem solid #00000033;\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n    padding: 1.25rem 3.75rem;\n\n    @media (max-width: @md-screen) {\n      position: absolute;\n      bottom: 0;\n      max-width: 100vw;\n      padding: 1rem;\n\n      .gyramais-btn {\n        width: 100%;\n      }\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
